import { render, staticRenderFns } from "./word2vec.vue?vue&type=template&id=019ae51e&"
import script from "./word2vec.vue?vue&type=script&lang=js&"
export * from "./word2vec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports